module.exports = __webpack_public_path__ + "static/media/bg_12.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_12.png
// module id = 57
// module chunks = 0